import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_bridge_order_payment} from "../../../../function/FnPosBridge";

@observer
class OrderPaymentAlertView extends Component {
    render() {

        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;

        return(
            <div className={"layer_comm layer_common_type "+(layerStore.getLayerOrderPaymentAlertView?' layer_open':'')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section_tit_comm">
                            <h1>포장 후불결제 알람</h1>
                        </div>
                        <div className="section_soldout">
                            <p className="txt_detail">
                                포장 주문에 대한 결제 정보가 없습니다.<br />결제를 진행하겠습니까?
                            </p>
                            <div className="wrap_full_btn wrap_full_btn2">
                                <button className="full"
                                        onClick={event => fn_bridge_order_payment(rootStore)}>
                                    <span className="ico_right">결제화면으로 이동</span>
                                </button>
                            </div>
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event=>layerStore.setLayerOrderPaymentAlertView(false)}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OrderPaymentAlertView;